// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3kCu-","right":"styles_right__2rCKx"};